import React from 'react';
import { Typography, Paper, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ConteoStock: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Conteo de Stock
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => navigate('/inventario/conteo/nuevo')}
        sx={{ mb: 2 }}
      >
        Nuevo Conteo
      </Button>
      {/* Aquí irá la tabla de conteos */}
    </Paper>
  );
};

export default ConteoStock; 